import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { hasSession, isSuperAdmin, needsPasswordChange } from "./auth/authSession";
import CompanyAssignedRoute from "./CompanyAssignedRoute";
import { PermissionContext } from "./PermissionContext";
import { hasAnyPermission } from "./utils/permissions";

const hasRequiredAccess = (permissions, requiredPermission, anyOf) => {
  if (Array.isArray(anyOf) && anyOf.length) {
    return hasAnyPermission(permissions, anyOf);
  }
  if (requiredPermission) {
    return permissions.includes(requiredPermission);
  }
  return true;
};

const ProtectedRoute = ({ children, requiredPermission, anyOf }) => {
  const { permissions, loading } = useContext(PermissionContext);

  if (!hasSession()) {
    return <Navigate to="/login" replace />;
  }

  if (needsPasswordChange()) {
    return <Navigate to="/change-password" replace />;
  }

  if (loading) return <div>Loading...</div>;

  if (!isSuperAdmin() && !hasRequiredAccess(permissions, requiredPermission, anyOf)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <CompanyAssignedRoute>{children}</CompanyAssignedRoute>;
};

export default ProtectedRoute;
